import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { validateResponse } from "@/api/validateResponse";
import { ContractEventListResponseSchema } from "@/api/types/contractEvents";

/** Query-key factory — mirrors reviewKeys'/quoteKeys' convention. */
export const contractEventKeys = {
  all: ["contractEvents"] as const,
  list: (contractId: string | undefined) => [...contractEventKeys.all, "list", contractId] as const,
};

/**
 * GET /v2/contracts/{id}/events — the ordered (oldest -> newest) append-only
 * signature/audit trail for one contract. Disabled until a contractId is
 * available (same `enabled` gating convention as the other detail hooks).
 */
export function useContractEvents(contractId: string | undefined) {
  return useQuery({
    queryKey: contractEventKeys.list(contractId),
    queryFn: async () => {
      const { data } = await apiClient.get(`/v2/contracts/${contractId}/events`);
      return validateResponse(ContractEventListResponseSchema, data, "GET /v2/contracts/:id/events");
    },
    enabled: !!contractId,
    staleTime: 15 * 1000,
  });
}
